import { CSSResultGroup, TemplateResult, html } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './tufts-search-result.css.lit';
import headingStyle from '../tufts-heading/tufts-heading.css.lit';
import '../tufts-heading/tufts-heading';
import { SlotNGController } from '../../controllers/slot-ng-controller';

/**
 * The tuftSearchResult component
 * @element tufts-search-result
 *
 * @slot heading
 * @slot eyebrow
 * @slot additional-info
 * @slot description
 *
 * @attr url
 * @attr link-icon
 */
@customElement('tufts-search-result')
export class tuftSearchResult extends OutlineElement {
  ngSlot = new SlotNGController(this);

  static styles: CSSResultGroup = [componentStyles, headingStyle];
  /**
   * URL for card
   **/
  @property({
    type: String,
    reflect: true,
    attribute: 'url',
  })
  url: string;

  /**
   * Is link external (open in new tab)
   **/
  @property({
    type: String,
    reflect: true,
    attribute: 'link-icon',
  })
  linkIcon = null;

  render(): TemplateResult {
    return html`
      <section>
        <div class="main-wrapper">
          ${this.ngSlot.conditionalNGSlot('eyebrow', true, 'xs')}
          ${this.headingTemplate()}
          ${this.ngSlot.conditionalNGSlot('additional-info')}
          ${this.ngSlot.conditionalNGSlot('description')}
          ${this.linkIcon
            ? html` <div class="link" aria-hidden="true">
                ${this.linkIcon === 'external' ? html`⎋` : html`➞`}
              </div>`
            : null}
        </div>
      </section>
    `;
  }

  headingTemplate(): TemplateResult {
    if (this.ngSlot.exist('heading')) {
      return html` ${this.url
        ? html` <div class="heading">
            <tufts-heading text-color="heading-color" level-size="md"
              ><h4>
                <a
                  href="${this.url}"
                  target=${ifDefined(
                    this.linkIcon === 'external' ? '_blank' : undefined
                  )}
                >
                  ${this.ngSlot.renderInShadow('heading')}
                </a>
              </h4>
            </tufts-heading>
          </div>`
        : this.ngSlot.conditionalNGSlot('heading', true, 'md')}`;
    }
    return html``;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-search-result': tuftSearchResult;
  }
}
